import request from '../axios';
export const addViolation = async (payload: IAddViolationPayload) => {
  const {data}: {data: IResponse} = await request.post(
    `/api/profile/violate-report`,
    payload,
  );
  return data;
};
